import { Space } from '@kl/components-v6';
import styled from 'styled-components';

export const StyledSpace = styled(Space)`
    padding-top: 6em;
    max-width: 1030px;
    margin: 0 auto;
    width: 100%;
`;

export const StyledUl = styled.ul`
    padding: 0;
    margin: 0;
    list-style-type: none;
`;
